import {useEffect, useState} from "react";
import Form from "react-bootstrap/Form";
import {useTranslation} from "react-i18next";
// -
import {MiniQ2ServerValuesModel, MiniQ2ServerHasModel} from "./models/MiniQ2Models";
import useCustomTranslation from "core/customTranslation";
import translations from "../../translations";
import RowTRComponent from "../../../components/RowTRComponent";

const MiniQ2FormS = ({item}) => {
    const {t: _Tf} = useTranslation("forms");
    const {t: _TC} = useCustomTranslation(translations);
    const [values, setValues] = useState({...MiniQ2ServerValuesModel});
    const [has, setHas] = useState({...MiniQ2ServerHasModel});
    const styleCenterMiddle = {textAlign: "center", verticalAlign: "middle"};

    useEffect(() => {
        if (item.id) {
            setValues({...item.values});
            setHas({...item.has});
        } else {
            setValues({...MiniQ2ServerValuesModel});
            setHas({...MiniQ2ServerHasModel});
        }
    }, [item]);

    const onChangeSelect= (e) => {
        const {name, value} = e.target;
        let values_ = {...values};
        values_[name] = value;
        setValues({...values_});
    }
    return (
        <div className="row">
            <div className="col-12 mb-5">
                <table className="table table-striped mb-5">
                    <thead>
                    <tr>
                        <th>{_Tf("common.name")}</th>
                        <th>{_Tf("common.description")}</th>
                        <th className="text-center">{_Tf("common.parameters")}</th>
                        <th style={{width: "35px", textAlign: "center"}}>{_Tf("common.actives")}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>{_TC("preference_sim")}</td>
                        <td>{_TC("preference_sim.description")}</td>
                        <td>
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="text-md-end mt-2">
                                        <label htmlFor="days" className="form-label">{_TC("preference_sim")}</label>
                                    </div>
                                </div>
                                <div className="col-md-4 d-flex align-items-center">
                                    <Form.Select
                                        className="mb-2"
                                        id="preference_sim"
                                        name="preference_sim"
                                        value={values.preference_sim}
                                        title={_TC("preference")}
                                        onChange={onChangeSelect}
                                        style={{minWidth: "110px"}}
                                    >
                                        <option value="Preferido SIM0">{_TC("preference_sim.choices.preference_sim0")}</option>
                                        <option value="Preferido SIM1">{_TC("preference_sim.choices.preference_sim1")}</option>
                                        <option value="Solo SIM0">{_TC("preference_sim.choices.only_sim0")}</option>
                                        <option value="Solo SIM1">{_TC("preference_sim.choices.only_sim1")}</option>
                                    </Form.Select>
                                </div>
                            </div>
                        </td>
                        <td style={styleCenterMiddle}></td>
                    </tr>
                    <tr><td colSpan="4" style={{textAlign: "center"}}><strong>SIM 0</strong></td></tr>
                    <tr>
                        <td>{_TC("sim0_band")}</td>
                        <td>{_TC("sim0_band.description")}</td>
                        <td>
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="text-md-end mt-2">
                                        <label htmlFor="days" className="form-label">{_TC("sim0_band")}</label>
                                    </div>
                                </div>
                                <div className="col-md-4 d-flex align-items-center">
                                    <Form.Select
                                        className="mb-2"
                                        id="sim0_band"
                                        name="sim0_band"
                                        value={values.sim0_band}
                                        title={_TC("band")}
                                        onChange={onChangeSelect}
                                        style={{minWidth: "110px"}}
                                    >
                                        <option value="Automático">{_TC("band.choices.auto")}</option>
                                        <option value="Preferido 4G">{_TC("band.choices.preferred4g")}</option>
                                        <option value="Preferido 2G">{_TC("band.choices.preferred2g")}</option>
                                        <option value="Solo 4G">{_TC("band.choices.only4g")}</option>
                                        <option value="Solo 2G">{_TC("band.choices.only2g")}</option>
                                    </Form.Select>
                                </div>
                            </div>
                        </td>
                        <td style={styleCenterMiddle}></td>
                    </tr>
                    <RowTRComponent
                        fieldName="sim0_pin"
                        _TC={_TC}
                        valueIn={values.sim0_pin}
                        hasIn={has.has_sim0_pin}
                        deactivated={MiniQ2ServerValuesModel.sim0_pin}
                        styleCenterMiddle={styleCenterMiddle}
                        inputProps={{
                            maxLength: "4",
                            "data-default": "0000"
                        }}
                    />
                    <RowTRComponent
                        fieldName={"sim0_apn_name"}
                        _TC={_TC}
                        valueIn={values.sim0_apn_name}
                        hasIn={has.has_sim0_apn_name}
                        deactivated={MiniQ2ServerValuesModel.sim0_apn_name}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"sim0_apn_user"}
                        _TC={_TC}
                        valueIn={values.sim0_apn_user}
                        hasIn={has.has_sim0_apn_user}
                        deactivated={MiniQ2ServerValuesModel.sim0_apn_name}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"sim0_apn_pass"}
                        _TC={_TC}
                        valueIn={values.sim0_apn_pass}
                        hasIn={has.has_sim0_apn_pass}
                        deactivated={MiniQ2ServerValuesModel.sim0_apn_pass}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <tr><td colSpan="4" style={{textAlign: "center"}}><strong>SIM 1</strong></td></tr>
                    <tr>
                        <td>{_TC("sim1_band")}</td>
                        <td>{_TC("sim1_band.description")}</td>
                        <td>
                            <div className="row">
                                <div className="col-md-8">
                                    <div className="text-md-end mt-2">
                                        <label htmlFor="days" className="form-label">{_TC("sim1_band")}</label>
                                    </div>
                                </div>
                                <div className="col-md-4 d-flex align-items-center">
                                    <Form.Select
                                        className="mb-2"
                                        id="sim1_band"
                                        name="sim1_band"
                                        value={values.sim1_band}
                                        title={_TC("band")}
                                        onChange={onChangeSelect}
                                        style={{minWidth: "110px"}}
                                    >
                                        <option value="Automático">{_TC("band.choices.auto")}</option>
                                        <option value="Preferido 4G">{_TC("band.choices.preferred4g")}</option>
                                        <option value="Preferido 2G">{_TC("band.choices.preferred2g")}</option>
                                        <option value="Solo 4G">{_TC("band.choices.only4g")}</option>
                                        <option value="Solo 2G">{_TC("band.choices.only2g")}</option>
                                    </Form.Select>
                                </div>
                            </div>
                        </td>
                        <td style={styleCenterMiddle}></td>
                    </tr>
                    <RowTRComponent
                        fieldName="sim1_pin"
                        _TC={_TC}
                        valueIn={values.sim1_pin}
                        hasIn={has.has_sim1_pin}
                        deactivated={MiniQ2ServerValuesModel.sim1_pin}
                        styleCenterMiddle={styleCenterMiddle}
                        inputProps={{
                            maxLength: "4",
                            "data-default": "0000"
                        }}
                    />
                    <RowTRComponent
                        fieldName={"sim1_apn_name"}
                        _TC={_TC}
                        valueIn={values.sim1_apn_name}
                        hasIn={has.has_sim1_apn_name}
                        deactivated={MiniQ2ServerValuesModel.sim1_apn_name}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"sim1_apn_user"}
                        _TC={_TC}
                        valueIn={values.sim1_apn_user}
                        hasIn={has.has_sim1_apn_user}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    <RowTRComponent
                        fieldName={"sim1_apn_pass"}
                        _TC={_TC}
                        valueIn={values.sim1_apn_pass}
                        hasIn={has.has_sim1_apn_pass}
                        deactivated={MiniQ2ServerValuesModel.sim1_apn_pass}
                        styleCenterMiddle={styleCenterMiddle}
                    />
                    </tbody>
                </table>
            </div>
        </div>
    )
}
export default MiniQ2FormS